import React from 'react'
import { Navigate, Route, Routes, useLocation } from 'react-router-dom'
import Path, { ProtectedRoutes, PublicRoutes } from './localRoutes'
import Privacy from '../modules/Common/Privacy/Privacy'
import Terms from '../modules/Common/Terms/Terms'
import ProtectedRoute from './ProtectedRoutes'
import NotFound from '../components/NotFound'

const Router = () => {
  const location = useLocation()

  return (
    <Routes location={location} key={location.pathname}>
      {PublicRoutes.map((itm) => (
        <Route key={itm.path} element={itm.element} path={itm.path} />
      ))}

      {ProtectedRoutes.map((itm) => (
        <Route
          key={itm.path}
          element={
            <ProtectedRoute allowedRoles={itm.allowedRoles}>
              {itm.element}
            </ProtectedRoute>
          }
          path={itm.path}
        />
      ))}

      <Route element={<Navigate to={Path.Role} />} path="/" />
      <Route element={<Privacy />} path={Path.PrivacyPolicy} />
      <Route element={<Terms />} path={Path.Terms} />
      <Route element={<NotFound />} path={Path.NotFound} />
      <Route element={<Navigate to={Path.NotFound} />} path="*" />
    </Routes>
  )
}

export default Router
